import React from 'react'
import Select from 'react-select'
import styled from 'styled-components'
import { CategorySkillOption } from '../WorkPreference/Registration/ThirdForm/types'


export type StyledTextAutoCompleteProps = {
  categoryId: number
  onChange: (option: { value: number, label: string }) => void
  skillOption: CategorySkillOption[]
  dataCy?: string
} & React.SelectHTMLAttributes<HTMLSelectElement>

const StyledSelect = styled(Select)`
  width: 100%;

  /* Main container */
  .select__control {
    // styles for the control
    height: 3rem;
    font-size: .875rem;
    border-radius: 0;
    background-color: ${props => props.theme.members.colors.white};
    color: ${props => props.theme.members.colors.black._100};
    border: 1px solid ${props => props.theme.members.colors.silver._70};
  }

  /* Input */
  .select__input {
    // styles for the input
  }

  .select__value-container {
    position: static;
    padding: 0 1rem;
    color: ${props => props.theme.members.colors.black._100};
  }

  /* Dropdown menu */
  .select__menu {
    // styles for the menu
  }

  /* Option in dropdown */
  .select__option {
    font-size: .875rem;
    padding: .5rem 1rem;
  }

  /* Selected value */
  .select__single-value {
    margin: 0;

    + div {
      margin: 0;
    }
  }

  /* Dropdown indicators (arrow) */
  .select__indicators {
    // styles for the indicator container
  }

  .select__indicator {
    color: ${props => props.theme.members.colors.silver._70};

    &:hover {
      color: ${props => props.theme.members.colors.silver._70};
    }
  }

  /* Dropdown indicator (arrow) */
  .select__indicator-separator {
    display: none;
  }

  .select__placeholder {
    margin: 0;
  }
`

export const StyledTextAutoComplete: React.FC<StyledTextAutoCompleteProps> = (props: StyledTextAutoCompleteProps) => {
    return (
      <StyledSelect
        {...props}
        classNamePrefix="select"
        options={props.skillOption}
        onChange={(selectedOption) => {
          if (selectedOption) {
            props.onChange({
              value: selectedOption.value,
              label: selectedOption.label
            });
          }
        }}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator: () => null,
        }}
      />
    )
}
